let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jmeku")).then(() => parcelRequire('7qoUq'));